// extracted by mini-css-extract-plugin
module.exports = {"navDotWrapper":"tY","navDot":"tZ","isRental":"t0","navDotActive":"t1"};